var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundGmEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "#F4F6F8",
    stroke: "#181B1A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.498 7.49463V13.8835L21.9962 16.2965L16.498 7.49463Z",
    fill: "#454A75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.4989 7.49463L11 16.2965L16.4989 13.8835V7.49463Z",
    fill: "#454A75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.498 20.4364V24.7775L21.9999 17.3018L16.498 20.4364Z",
    fill: "#454A75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.4989 24.7775V20.4357L11 17.3018L16.4989 24.7775Z",
    fill: "#454A75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 19.4324L21.9962 16.297L16.498 13.8855V19.4324Z",
    fill: "#454A75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11 16.297L16.4989 19.4324V13.8855L11 16.297Z",
    fill: "#454A75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundGmEth);
export default __webpack_public_path__ + "static/media/roundGmETH.07726b34cff1c2d17e4be35940c9a9dd.svg";
export { ForwardRef as ReactComponent };